import { registerMathSchemas } from './node-schemas/math-schemas'
import { registerTechnicalSchemas } from './node-schemas/technical-schemas'
import { registerLogicSchemas } from './node-schemas/logic-schemas'
import { registerUtilitySchemas } from './node-schemas/utilities-schemas'
import { registerFilterSchemas } from './node-schemas/filter-schemas'
import { registerDataSchemas } from './node-schemas/data-schemas'
import { registerStrategySchemas } from './node-schemas/strategy-schemas'
import { registerTradeManagerSchema } from './node-schemas/trade-manager-schema'
import { registerSessionMetricSchema } from './node-schemas/session-metric-schema'
import { registerReportSchema } from './node-schemas/report-schema'
import { registerDebugSchemas } from './node-schemas/debug-schemas'
import { registerCSVSchemas } from './node-schemas/csv-schema'
import { registerUniverseSchemas } from './node-schemas/universe-schema'

let registered = false

export function registerAllNodeSchemas(): void {
  if (registered) return
  registered = true
  registerMathSchemas()
  registerTechnicalSchemas()
  registerLogicSchemas()
  registerUtilitySchemas()
  registerSessionMetricSchema()
  registerFilterSchemas()
  registerDataSchemas()
  registerStrategySchemas()
  registerTradeManagerSchema()
  registerReportSchema()
  registerDebugSchemas()
  registerCSVSchemas()
  registerUniverseSchemas()
}
